import React from 'react';
import isEmpty from 'lodash/isEmpty';
import PollingAnalysis from './PollingAnalysis';
import { executingAnalysesSelector } from '../../redux/selectors/executingAnalyses';
import { useAppSelector } from '../../redux/hooks';

/**
 * In the latest implementation, if an analysis is executed,
 * the AnalysisQuery will return the analysis with status 'running/pending' immediately.
 * But for the normal analysis(data is ready in Kobol), it will return the analysis in one time.
 *
 * Under this rule, we need to make sure 4 things:
 * 1. If analysis is running/pending, we need to refetch the AnalysisQuery until the analysis is completed.
 * 2. if analysis is loaded, no matter where user is,  we need to tell user
 *    the executing analysis is completed and provide redirect toast message if not in the curr analysis page.
 * 3. User can execute multiple analyses at the same time.
 * 4. During this process, user is able to check other analyses by clicking analysis from History.
 *
 * Approach: keep this component exist all the time, and seperate two queris: data ready in kobol and not ready.
 * If the data is not ready, we poll the query until the analysis is completed.
 * If the data is ready, we will load the data in ExecutionHistory.tsx.
 *
 * @executingAnalyses that contains all executed analysis ids and their status (initialized/running/completed).
 * It will be used to skip the data fetch at useEffect if the analysis is in the process.
 * This list will be kept in memory until close the tab or refresh the page.
 *
 *
 */

export default () => {
  const executingAnalyses = useAppSelector(executingAnalysesSelector);

  if (isEmpty(executingAnalyses)) {
    return null;
  }

  return (
    <>
      {Object.keys(executingAnalyses).map((analysisId) => (
        <PollingAnalysis
          key={`polling-${analysisId}`}
          analysisId={analysisId}
        />
      ))}
    </>
  );
};
